import { EnabledCookieGroups, CookiesActions } from './types';

export const setEnabledCookieGroups = (enabledCookieGroups: EnabledCookieGroups) => {
  return {
    type: CookiesActions.SetEnabledCookieGroups,
    payload: enabledCookieGroups,
  };
};
